module.exports = __webpack_public_path__ + "img/pr-4.a84029b3.png";